export const StoreInventoryManagementStorageKey = 'store-inventory';
